import { render, staticRenderFns } from "./Kemitraan.vue?vue&type=template&id=12326862&"
import script from "./Kemitraan.vue?vue&type=script&lang=js&"
export * from "./Kemitraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports